import React from 'react';
import Page from '@/components/Layout/Page';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { RolesNotificationsTable } from './RolesNotificationsTable';

const EmployeeConfirmPage: React.FC = () => {
  return (
    <Page>
      <div className="max-w-3xl mx-auto">
        <Card className="mb-3">
          <CardHeader>
            <CardTitle>Invitaciones Pendientes</CardTitle>
          </CardHeader>
          <CardContent>
            <RolesNotificationsTable />
          </CardContent>
        </Card>
      </div>
    </Page>
  );
};

export default EmployeeConfirmPage;
